import {
  makeRequired, repeatPasswordValidator,
} from '../../../../../OUI/Inputs';

export const newPasswordRepeatFieldValidator = makeRequired(repeatPasswordValidator('newPassword'));
